import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { api, setAdminToken } from "@/lib/api";

export default function AdminLogin() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await api.post("/admin/login", { email, password });
            setAdminToken(data.token);
            toast.success("Welcome back.");
            navigate("/admin");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Invalid credentials");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="intake-shell flex items-center justify-center px-6 py-12" data-testid="admin-login-page">
            <div className="intake-card w-full max-w-md p-10 animate-fade-up">
                <div className="w-12 h-12 rounded-xl bg-[#D4AF37]/10 border border-[#D4AF37]/30 flex items-center justify-center mb-6">
                    <Lock className="text-[#D4AF37]" size={20} />
                </div>
                <h1 className="font-display text-3xl text-white">Staff sign in</h1>
                <p className="mt-2 text-sm text-white/55">Authorized personnel only.</p>

                <form onSubmit={submit} className="mt-8 space-y-5">
                    <div>
                        <label className="field-label block mb-2">Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="glow-input w-full px-4 py-3 rounded-xl text-sm"
                            placeholder="admin@aurumcredit.com"
                            data-testid="admin-email-input"
                            autoComplete="username"
                            required
                        />
                    </div>
                    <div>
                        <label className="field-label block mb-2">Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="glow-input w-full px-4 py-3 rounded-xl text-sm"
                            placeholder="••••••••"
                            data-testid="admin-password-input"
                            autoComplete="current-password"
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={loading}
                        className="btn-gold w-full py-3 inline-flex items-center justify-center gap-2"
                        data-testid="admin-login-btn"
                    >
                        {loading && <Loader2 size={16} className="animate-spin" />}
                        Sign in
                    </button>
                </form>
            </div>
        </div>
    );
}
